import { IExternalImageSource } from "./IExternalImageSource";

export class ExternalImageItem {
  constructor(public patientId: string, public id: string, public imageDateTime: Date, public source: IExternalImageSource) {
  }
}
